var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusCircleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#01313D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 15C9.79762 15 9.6281 14.9314 9.49143 14.7943C9.35429 14.6576 9.28571 14.4881 9.28571 14.2857V10.7143H5.71429C5.5119 10.7143 5.34214 10.6457 5.205 10.5086C5.06833 10.3719 5 10.2024 5 10C5 9.79762 5.06833 9.62786 5.205 9.49071C5.34214 9.35405 5.5119 9.28571 5.71429 9.28571H9.28571V5.71429C9.28571 5.5119 9.35429 5.34214 9.49143 5.205C9.6281 5.06833 9.79762 5 10 5C10.2024 5 10.3721 5.06833 10.5093 5.205C10.646 5.34214 10.7143 5.5119 10.7143 5.71429V9.28571H14.2857C14.4881 9.28571 14.6576 9.35405 14.7943 9.49071C14.9314 9.62786 15 9.79762 15 10C15 10.2024 14.9314 10.3719 14.7943 10.5086C14.6576 10.6457 14.4881 10.7143 14.2857 10.7143H10.7143V14.2857C10.7143 14.4881 10.646 14.6576 10.5093 14.7943C10.3721 14.9314 10.2024 15 10 15Z",
    fill: "#FAF2E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircleIcon);
export default __webpack_public_path__ + "static/media/plus-circle-icon.30dec06503246b069a49ea21727aa9f2.svg";
export { ForwardRef as ReactComponent };